import React from 'react'
import ReactDOM from 'react-dom/client'
import { FluentProvider } from '@fluentui/react-components'
import './index.css'
import AppWrapper from './App'
import { ThemeProvider, useTheme } from './contexts/ThemeContext'
import { EffectsProvider } from './contexts/EffectsContext'
import ErrorBoundary from './components/ErrorBoundary'

// Ensure React is available globally for Fluent UI
if (typeof window !== 'undefined') {
	(window as any).React = React
}

const ThemedApp = () => {
	const { fluentTheme } = useTheme()
	return (
		<FluentProvider theme={fluentTheme} dir="ltr">
			<ErrorBoundary>
				<AppWrapper />
			</ErrorBoundary>
		</FluentProvider>
	)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<ThemeProvider>
			<EffectsProvider>
				<ThemedApp />
			</EffectsProvider>
		</ThemeProvider>
	</React.StrictMode>,
)
